"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.EagerLoadImage = void 0;
var _mui = require("@ori-ui/mui");
var _common = require("../../common");
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  img: {
    height: '100%',
    width: '100%'
  }
}));
const EagerLoadImage = exports.EagerLoadImage = (0, _mui.styled)('img')(({
  theme
}) => ({
  ...(0, _common.getLoadingAnimationForEmptyImage)(theme)
}));
//# sourceMappingURL=styles.js.map